import React, { createContext, ReactNode, useContext, useEffect, useRef, useState } from 'react'

import { Location, useLocation } from 'react-router-dom'

// Define the type for the NavigationContext value
interface NavigationContextValue {
  setError: (error: string | null) => void
  error: string | null
  previousLocation: Location | null
}

// Create a new context for navigation
const NavigationContext = createContext<NavigationContextValue | undefined>(undefined)
NavigationContext.displayName = 'NavigationContext'
// Create a provider component
export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation()
  const [error, setError] = useState<string | null>(null)
  const previousLocationRef = useRef<Location | null>(null)

  useEffect(() => {
    previousLocationRef.current = location
  }, [location])

  return (
    <NavigationContext.Provider value={{ previousLocation: previousLocationRef?.current, setError, error }}>
      {children}
    </NavigationContext.Provider>
  )
}

// Hook to use the navigate function and setError from the context
const useNavigation = (): NavigationContextValue => {
  const context = useContext(NavigationContext)

  if (context === undefined) {
    throw new Error(`useNavigation must be used within a NavigationProvider`)
  }

  return context
}

export { useNavigation, NavigationContext }
